
import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import PricingPlans from "@/components/pricing/PricingPlans";
import PricingHeader from "@/components/pricing/PricingHeader";
import { supabase } from "@/integrations/supabase/client";

interface PricingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  returnUrl?: string; // Add returnUrl prop
}

const PricingDialog = ({ open, onOpenChange, returnUrl }: PricingDialogProps) => {
  const [currency, setCurrency] = useState<string>("KES");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          const { data: profile } = await supabase
            .from('profiles')
            .select('currency, country')
            .eq('id', user.id)
            .single();
          
          if (profile) {
            // Use the user's selected currency or default based on country
            const userCurrency = profile.currency || 
              (profile.country === "Ethiopia" ? "Birr" : "KES");
            setCurrency(userCurrency);
          }
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (open) {
      fetchUserProfile();
    }
  }, [open]);

  // Normalize the return URL to ensure it properly handles redirects
  const normalizedReturnUrl = returnUrl || "/dashboard/settings/subscription?success=true";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto p-0">
        <div className="py-6 px-4 space-y-8">
          {!isLoading && <PricingHeader currency={currency} />}
          <PricingPlans currency={currency} returnUrl={normalizedReturnUrl} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PricingDialog;
